export const api_url = "https://proteinapp-ad.me";



export const version_app = "3.4.0";


export const publishable_api_key_moyasar = "pk_live_vWEn9nHGjiaMZ2PKBj5NGyXrTq6A9rjx5WhxkTmQ"

//https://localhost:5001



//https://protein40app.xyz